<template>
  <section class="add">
    <ServerPopup
      v-if="serverPopup.opened"
      v-model="serverPopup.modelValue"
      :mode="serverPopup.mode"
      @close="onServerPopupClose"
      @approve="onServerPopupApprove"
    />
    <Header class="add__header">
      <template v-slot:title>Настроить телеметрию</template>
    </Header>
    <BackButton router-page-name="MeterConfigs" class="address__back">
      Назад
    </BackButton>
    <!-- <p class="add__message">
      Выгрузить из BasIP файлы с абонентами и загрузите сюда (справка по
      формату файла). <br />
      Можно добавить один файл по каждому адресу.
    </p> -->

    <div v-for="(address, index) in addressList" :key="address.id">
      <Address
        v-model:form="address.form"
        :index="index + 1"
        :removable="index > 0"
        :formList="formList"
        @remove="removeAddress(address.id)"
      />
    </div>

    <div class="add__actions">
      <Actions :actions="actions.default" />
    </div>
  </section>
</template>

<script>
import Header from "../../components/Header.vue";
import Actions from "../../components/Actions.vue";
import BackButton from "../../components/BackButton.vue";
import Address from "./Address.vue";
import ServerPopup from "../Popup/Server.vue";
import MockServer from "../../mixins/Mock/MockServer.js";
import AddMeterConfig from "../../mixins/Mock/AddMeterConfig.js";

export default {
  name: "AddMeterConfig",
  mixins: [MockServer, AddMeterConfig],
  components: { Header, ServerPopup, Actions, Address, BackButton },
};
</script>

<style lang="scss" scoped>
.add {
  width: 100%;

  &__header {
    margin: 0px $space-md $space-xxl;
  }

  &__message {
    margin: 0px $space-md $space-md;
  }
}
</style>
